import { FallbackProps } from "../../../node_modules/react-error-boundary";
import { ExclamationTriangle } from "react-bootstrap-icons";
import { useNavigate } from "react-router";
import("./ErrorFallback.css");

const ErrorFallback: React.FC<FallbackProps> = ({ error }) => {
    const navigate = useNavigate();

    return (
        <div className="d-flex flex-column align-items-center mt-5">
            <div className="mt-5">
                <div className="d-flex align-items-center gap-3 my-4">
                    <ExclamationTriangle className="flex-shrink-0 theme-tealtext display-5" />
                    <h3 className="theme-tealtext">Something went wrong!</h3>
                </div>

                <hr />

                {error && (error as Error).message ?
                    <p className="text-start theme-tealtext">
                        <b>{(error as Error).message}.</b>
                        <br />
                        Please try refreshing the page or go back and try again.
                    </p>
                :   <p className="text-start theme-tealtext">
                        An unexpected error occurred.
                        <br />
                        Please try refreshing the page or go back and try again.
                    </p>
                }
                <div className="text-end my-4">
                    <button
                        className="btn e-theme-button me-3"
                        onClick={() => navigate(-1)}
                        style={{ minWidth: "120px" }}
                    >
                        Back
                    </button>

                    <button
                        className="btn e-theme-button"
                        onClick={() => window.location.reload()}
                        style={{ minWidth: "120px" }}
                    >
                        Refresh
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ErrorFallback;
